import { motion } from 'framer-motion';

const programs = [
  {
    id: 1,
    title: 'Farmer Security Program',
    description: "Protecting Nigeria's food producers and rural livelihoods through emergency response drills and rapid deployment.",
    image: 'https://nigeria234.com/wp-content/uploads/2025/08/nigeria-agriculture.jpeg',
    link: '/programs',
  },
  {
    id: 2,
    title: 'Better Responder Initiative',
    description: "Equipping and training emergency responders across all national security and volunteer networks.",
    image: 'https://res.cloudinary.com/ddf1wv47y/image/upload/v1744053866/Screenshot_2025-04-07_at_8.21.42_PM_pobqqt.png',
    link: '/programs',
  },
];

export default function ModernProgramsSection() {
  return (
    <section className="py-24 sm:py-32 bg-[#F8FAFC] text-[#0F172A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="space-y-32">
          {programs.map((program, index) => (
            <div
              key={program.id}
              className={`flex flex-col lg:flex-row items-center gap-16 lg:gap-24 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Content */}
              <motion.div
                initial={{ opacity: 0, x: index % 2 === 1 ? 40 : -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="w-full lg:w-1/2 flex flex-col items-start"
              >
                <h2 className="font-sans text-4xl sm:text-5xl font-bold tracking-tight mb-6">
                  {program.title}
                </h2>
                <p className="text-xl text-[#0F172A]/70 font-light leading-relaxed mb-10 max-w-lg">
                  {program.description}
                </p>
                <a
                  href={program.link}
                  className="inline-flex items-center text-lg font-semibold text-[#16A34A] hover:text-[#15803d] transition-colors group"
                >
                  Learn More
                  <svg
                    className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </a>
              </motion.div>

              {/* Image */}
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="w-full lg:w-1/2"
              >
                <div className="rounded-3xl overflow-hidden shadow-2xl bg-gray-100 aspect-[4/3]">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}